import type { Template } from '@tunasong/plugin-lib'
import type { Poll } from '@tunasong/schemas'
import rehearsalTemplate from './template-rehearsal.js'
import template from './template.js'

export const pollTemplates: Template<Poll>[] = [
  { name: 'Poll', template },
  {
    name: 'Rehearsal poll',
    /** Without this the picker falls back to the plugin description and both cards read "Poll". */
    description: 'Find a night the band can play',
    template: rehearsalTemplate,
  },
]
